module.exports = __webpack_public_path__ + "img/es2.4ea0ef72.jpg";